import React from "react";
import { CardBody, Row, Col, Card, Container, Spinner } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { Link } from "react-router-dom";

import useSWR from "swr";
import { useSelector } from "react-redux";

import { APIClient } from "../../utils/api_helper";

import { useParams } from "react-router-dom";
import StatementSkeleton from "../../Components/Skeletons/StatementSkeleton";
import { Status } from "./TransactionsCol";

const api = new APIClient();

const transactionListFetcher = async (url) => {
  const data = await api.get(url);

  return data;
};

const TransactionDetails = () => {
  const { id } = useParams();

  // Access a specific query parameter
  // const id = query.get("id");

  let { data, error, isValidating } = useSWR(`/transaction/${id || ""}`, transactionListFetcher, {
    revalidateOnFocus: false, // revalidate when the page gains focus
    revalidateOnReconnect: false, // revalidate when the browser regains network connectivity
  });

  let transaction = data?.data;

  //Print the Invoice
  const printTransaction = () => {
    window.print();
  };

  const { user } = useSelector((state) => ({
    user: state.Profile.user,
  }));
  const currentUserId = user?.uuid;

  console.log(user, "USERRR");

  const is_user_payer = (transaction) => {
    return transaction?.payer?.uuid === currentUserId;
  };

  const isCurrentUserPayer = is_user_payer(transaction);

  console.log(transaction, isCurrentUserPayer, "transactionVVVV");

  console.log(isCurrentUserPayer, "isCurrentUserPayer");

  const transactionItem = isCurrentUserPayer ? transaction?.recipient : transaction?.payer;

  document.title = "Transaction Details";

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Transaction Details" linkTo={"/transactions"} pageTitle="Transactions" />

        <StatementSkeleton>
          {transaction ? (
            <Row className="justify-content-center">
              <Col xxl={8}>
                <Card className="shadow-lg border-0 overflow-hidden">
                  <div className="bg-soft-primary position-relative">
                    <div className="card-body p-5 text-center">
                      <div className="mx-auto mb-4">
                        <div className="avatar-lg mx-auto">
                          <div className="avatar-title bg-soft-light text-primary rounded-circle display-4">
                            <i className={isCurrentUserPayer ? "ri-arrow-right-up-line text-danger" : "ri-arrow-left-down-line text-success"}></i>
                          </div>
                        </div>
                      </div>

                      <h6 className="text-uppercase fw-semibold mb-3 text-muted">Total Amount</h6>
                      <h2 className={`display-4 fw-bold mb-3 ${isCurrentUserPayer ? 'text-danger' : 'text-success'}`}>
                        {isCurrentUserPayer ? "-" : "+"} {user?.currency_symbol}{transaction?.amount}
                      </h2>

                      <div className="d-flex justify-content-center align-items-center gap-2 mb-4">
                        <Status status={transaction?.status} />
                        <span className="text-muted">|</span>
                        <span className="text-muted">{transaction?.created_at.split("T")[0]} {transaction?.created_at?.split("T")[1]?.split(".")[0]}</span>
                      </div>
                    </div>
                    <div className="shape">
                      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" width="1440" height="20" preserveAspectRatio="none" viewBox="0 0 1440 60">
                        <g mask="url(&quot;#SvgjsMask1001&quot;)" fill="none">
                          <path d="M 0,4 C 144,13 432,48 720,49 C 1008,50 1296,17 1440,9L1440 60L0 60z" fill="var(--vz-card-bg-custom)"></path>
                        </g>
                        <defs>
                          <mask id="SvgjsMask1001">
                            <rect width="1440" height="20" fill="#ffffff"></rect>
                          </mask>
                        </defs>
                      </svg>
                    </div>
                  </div>

                  <CardBody className="p-5">
                    <Row className="g-5">
                      <Col lg={6}>
                        <div className="ps-lg-3">
                          <h6 className="text-muted text-uppercase fw-semibold mb-3">Transaction Info</h6>

                          <div className="mb-4">
                            <p className="text-muted mb-1 text-uppercase fs-12 fw-medium">Reference ID</p>
                            <h5 className="fs-16 mb-0 fw-semibold">{transaction?.reference}</h5>
                          </div>

                          <div className="mb-4">
                            <p className="text-muted mb-1 text-uppercase fs-12 fw-medium">Payment Method</p>
                            <h5 className="fs-16 mb-0 fw-semibold">{transaction?.payment_method}</h5>
                          </div>

                          <div className="mb-0">
                            <p className="text-muted mb-1 text-uppercase fs-12 fw-medium">Type</p>
                            <span className={`badge ${isCurrentUserPayer ? 'badge-soft-danger' : 'badge-soft-success'} fs-12 text-uppercase`}>
                              {isCurrentUserPayer ? "Expense" : "Income"}
                            </span>
                          </div>
                        </div>
                      </Col>

                      <Col lg={6}>
                        <div className="pe-lg-3">
                          <h6 className="text-muted text-uppercase fw-semibold mb-3">{isCurrentUserPayer ? "Payment To" : "Payment From"}</h6>

                          {/* If simply-to-simply, show counterparty details nicely */}
                          {transaction?.payment_method === "simply" ? (
                            <>
                              <div className="d-flex align-items-center mb-3">
                                <div className="flex-shrink-0 avatar-sm me-3">
                                  <div className="avatar-title bg-soft-info text-info rounded-circle fs-20">
                                    {transactionItem?.first_name?.charAt(0)}{transactionItem?.last_name?.charAt(0)}
                                  </div>
                                </div>
                                <div>
                                  <h5 className="fs-16 mb-1 fw-semibold">{transactionItem?.first_name} {transactionItem?.last_name}</h5>
                                  <p className="text-muted mb-0">{transactionItem?.email || transactionItem?.phone}</p>
                                </div>
                              </div>

                              {transactionItem?.account_number && (
                                <div className="mb-3">
                                  <p className="text-muted mb-1 text-uppercase fs-12 fw-medium">Account Number</p>
                                  <h5 className="fs-16 mb-0">{transactionItem?.account_number}</h5>
                                </div>
                              )}
                            </>
                          ) : (
                            // External payment / withdrawal etc
                            <>
                              {transaction?.full_name && (
                                <div className="mb-4">
                                  <p className="text-muted mb-1 text-uppercase fs-12 fw-medium">Account Holder</p>
                                  <h5 className="fs-16 mb-0 fw-semibold">{transaction?.full_name}</h5>
                                </div>
                              )}

                              {transaction?.account_number && (
                                <div className="mb-4">
                                  <p className="text-muted mb-1 text-uppercase fs-12 fw-medium">Account Number</p>
                                  <h5 className="fs-16 mb-0 fw-semibold">{transaction?.account_number}</h5>
                                </div>
                              )}

                              <div className="mb-0">
                                <p className="text-muted mb-1 text-uppercase fs-12 fw-medium">Time</p>
                                <h5 className="fs-16 mb-0 fw-semibold">{transaction?.created_at_arrow}</h5>
                              </div>
                            </>
                          )}
                        </div>
                      </Col>
                    </Row>

                    <div className="mt-5 border-top border-top-dashed pt-4 d-flex justify-content-center">
                      <Link to="#" onClick={printTransaction} className="btn btn-success btn-lg shadow-sm">
                        <i className="ri-printer-line align-bottom me-1"></i> Print / Download
                      </Link>
                    </div>

                  </CardBody>
                </Card>
              </Col>
            </Row>
          ) : (
            <div className="text-center py-5">
              <Spinner color="primary" />
            </div>
          )}
        </StatementSkeleton>
      </Container>
    </div>
  );
};

export default TransactionDetails;
